import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PutApiConfirmationMutationRequest,
  PutApiConfirmationMutationResponse,
  PutApiConfirmation401,
  PutApiConfirmation403,
} from "../../../types/PutApiConfirmation";

export function getPutApiConfirmationUrl() {
  return `/api/Confirmation` as const;
}

/**
 * {@link /api/Confirmation}
 */
export async function putApiConfirmation(
  data?: PutApiConfirmationMutationRequest,
  config: Partial<RequestConfig<PutApiConfirmationMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const formData = new FormData();
  if (data) {
    Object.keys(data).forEach((key) => {
      const value = data[key as keyof typeof data];
      if (
        typeof key === "string" &&
        (typeof value === "string" || value instanceof Blob)
      ) {
        formData.append(key, value);
      }
    });
  }
  const res = await request<
    PutApiConfirmationMutationResponse,
    ResponseErrorConfig<PutApiConfirmation401 | PutApiConfirmation403>,
    PutApiConfirmationMutationRequest
  >({
    method: "PUT",
    url: getPutApiConfirmationUrl().toString(),
    data: formData,
    ...requestConfig,
    headers: {
      "Content-Type": "multipart/form-data",
      ...requestConfig.headers,
    },
  });
  return res;
}
